// import { throttle } from '@lsfe/tools';

const getScroll = (target, top) => {
    if (typeof window === 'undefined') {
        return 0;
    }

    const prop = top ? 'pageYOffset' : 'pageXOffset';
    const method = top ? 'scrollTop' : 'scrollLeft';
    const isWindow = target === window;
    let ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode

    if (isWindow && typeof ret !== 'number') {
        ret = document.documentElement[method];
    }

    return ret;
};

const getTargetRect = target => {
    const obj = {
        top: 0,
        left: 0,
        bottom: 0
    };
    return target !== window ? target.getBoundingClientRect() : obj;
};

const getOffset = (element, target) => {
    const elemRect = element.getBoundingClientRect();
    const targetRect = getTargetRect(target);
    const scrollTop = getScroll(target, true);
    const scrollLeft = getScroll(target, false);
    const docElem = window.document.body;
    const clientTop = docElem.clientTop || 0;
    const clientLeft = docElem.clientLeft || 0;
    return {
        top: elemRect.top - targetRect.top + scrollTop - clientTop,
        left: elemRect.left - targetRect.left + scrollLeft - clientLeft,
        width: elemRect.width,
        height: elemRect.height
    };
};

export const getEle = (className, target = document) => {
    return target.getElementsByClassName(className);
};

export const setStyle = (curEle, options, hasPrefix, tableName) => {
    const { offset, zIndex } = options;
    const cssText = `
        position: absolute;
        z-index: ${zIndex};
    `;
    let top = 0;
    if (hasPrefix) {
        top = getEle('table-prefix', curEle)[0].offsetHeight;
    }
    setTimeout(() => {
        const target = getEle('layout-page-content')[0];
        const headerEle = getEle('el-table__header-wrapper', curEle)[0];
        const bodyEle = getEle('el-table__body-wrapper', curEle)[0];
        let elemOffset = getOffset(headerEle, target);
        let isSetted = false;
        const setStyle = () => {
            const isIn = getTargetRect(headerEle).top !== 0;
            if (isIn) {
                if (!isSetted) {
                    elemOffset = getOffset(headerEle, target);
                }
                const scrollTop = getScroll(target, true);
                if (scrollTop >= elemOffset.top - offset) {
                    if (!isSetted) {
                        Array.prototype.slice.call(getEle('el-table__fixed-header-wrapper', curEle)).forEach(item => {
                            item.style.cssText = 'z-index: 4;';
                        });
                        headerEle.style.cssText = cssText;
                        bodyEle.style.cssText = `margin-top: ${elemOffset.height}px`;
                    }
                    headerEle.style.top = `${scrollTop - elemOffset.top}px`;
                    Array.prototype.slice.call(getEle('el-table__fixed-header-wrapper', curEle)).forEach(item => {
                        item.style.top = `${scrollTop - elemOffset.top}px`;
                    });
                    isSetted = true;
                } else {
                    isSetted = false;
                    headerEle.style.cssText = '';
                    bodyEle.style.cssText = '';
                    Array.prototype.slice.call(getEle('el-table__fixed-header-wrapper', curEle)).forEach(item => {
                        item.style.cssText = '';
                    });
                }
            }
        };
        target.addEventListener('scroll', setStyle);
    }, 1000);
};
